/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { UserContext } from '../../contexts/User';
import { NotificationContext } from '../../contexts/Notification';

function BalanceEditModal({ match, getMembers, onClose }) {
  const { activeWorkspace } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);

  const oldBalance = match.balance / 60;
  const hours = Math.floor(oldBalance / 60) < 10 ? `0${Math.floor(oldBalance / 60)}` : Math.floor(oldBalance / 60);
  const minutes = oldBalance % 60 < 10 ? `0${oldBalance % 60}` : oldBalance % 60;
  const [balance, setBalance] = useState(`${hours}:${Number(minutes).toFixed(2)}`);
  const [balanceValue, setBalanceValue] = useState(0);
  const [reason, setReason] = useState('');

  const handleBalance = (e) => {
    const { value } = e.target;
    setBalance(value);
    const parts = value.split(':');
    if (parts[0] && parts[1]) setBalanceValue(parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10));
    else setBalanceValue(0);
  };

  const handleEdit = async () => {
    if (!activeWorkspace) return;
    const response = await sendRequest({
      method: 'put',
      url: API.WORKSPACE.editOffTimeBalance(activeWorkspace.id),
      data: { balance: match, balanceValue, reason },
    });
    if (response.success) {
      displayNotification({ message: 'Edit the balance value successfully.', severity: 'success' });
      if (onClose) onClose();
      getMembers();
    } else {
      displayNotification({ message: 'An error occurs while editing data.', severity: 'error' });
    }
  };

  const inputCls = 'w-full box-border px-3 py-2 border border-rule rounded-[8px] text-sm text-ink-900 placeholder:text-ink-500 focus:outline-none focus:border-brand-500';

  return (
    <div
      className="bg-white rounded-[12px] border border-rule"
      style={{ position: 'absolute', top: 38, left: 8, width: 300, padding: 16, borderStyle: 'solid', zIndex: 10, boxShadow: '0 8px 24px rgba(14, 30, 64, 0.12)', textAlign: 'left' }}
    >
      <div className="mb-3">
        <span className="block text-sm font-medium text-ink-900 mb-1.5">Amount</span>
        <input value={balance} onChange={handleBalance} className={inputCls} style={{ borderStyle: 'solid' }} placeholder="HH:MM" />
      </div>
      <div className="mb-3">
        <span className="block text-sm font-medium text-ink-900 mb-1.5">Why are you modifying this?</span>
        <textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Required" className={inputCls} style={{ borderStyle: 'solid', minHeight: 80, resize: 'vertical' }} />
      </div>
      <button
        type="button"
        onClick={handleEdit}
        disabled={!balanceValue || !reason}
        className="inline-flex items-center justify-center box-border h-10 w-full px-4 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] disabled:opacity-40 disabled:cursor-not-allowed transition"
      >
        Apply
      </button>
    </div>
  );
}

BalanceEditModal.propTypes = {
  match: PropTypes.shape({
    id: PropTypes.number.isRequired,
    balance: PropTypes.number.isRequired,
    policyId: PropTypes.number.isRequired,
  }).isRequired,
  getMembers: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

BalanceEditModal.defaultProps = { onClose: () => {} };

export default BalanceEditModal;
